export const DEFAULT_LEDGER_TRANSPORT = 'u2f';
export const DEFAULT_LEDGER_OPEN_TIMEOUT = 15000;
export const DEFAULT_LEDGER_INTERACTIVE_TIMEOUT = 45000;
export const DEFAULT_LEDGER_NONINTERACTIVE_TIMEOUT = 5000;

export const LEDGER_EXPECTED_MAJOR_VERSION = 1;

export const DEFAULT_GET_ADDRESSES_LIMIT = 5;

export const DEFAULT_HD_PATH = [44, 714, 0, 0, 0];
